import React, { PropsWithChildren, useContext } from "react";

export type LogoUrlContext = {
  logoId: string | undefined;
  logoUrl: string | undefined;
};

export const logoUrlContext = React.createContext<LogoUrlContext | undefined>(
  undefined,
);

export type LogoUrlContextProviderProps = {
  logoId?: string;
  logoUrl?: string;
};

export function LogoUrlContextProvider(
  props: PropsWithChildren<LogoUrlContextProviderProps>,
) {
  return (
    <logoUrlContext.Provider
      value={{
        logoUrl: props.logoUrl,
        logoId: props.logoId,
      }}
    >
      {props.children}
    </logoUrlContext.Provider>
  );
}

export function useLogoUrlContext() {
  const context = useContext(logoUrlContext);
  if (!context) {
    throw new Error(
      "useLogoUrlContext must be used with LogoUrlContextProvider",
    );
  }
  return context;
}
